module.exports = __webpack_public_path__ + "img/cc_listing.0723eeaa.svg";